/**
 * Where `getConvexErrorMessage` puts an app error's English message into the
 * reader's language. The web app's product roots register a localizer in the
 * browser for a reader of another language (`ErrorMessagesBridge`); until
 * one does, and everywhere else (the server, `/v1`, MCP, Slack, logs), a
 * message stays English.
 *
 * LEAF MODULE, no imports: `lib/errors/app-error.ts` is part of the Convex
 * program (`convex/shared/errors.ts` imports it).
 */

type ErrorMessageLocalizer = (message: string) => string

let localizer: ErrorMessageLocalizer | null = null

/** One per document: the bridge replaces it on a language change, `null` removes it. */
export function setErrorMessageLocalizer(
  next: ErrorMessageLocalizer | null
): void {
  localizer = next
}

/** `message` in the reader's language, or unchanged without a localizer. */
export function localizeErrorMessage(message: string): string {
  if (localizer === null) {
    return message
  }
  try {
    return localizer(message)
  } catch {
    // Showing the English message beats failing to show an error.
    return message
  }
}
